import { render, staticRenderFns } from "./createDemand.vue?vue&type=template&id=7f56e1de&scoped=true"
import script from "./createDemand.vue?vue&type=script&lang=js"
export * from "./createDemand.vue?vue&type=script&lang=js"
import style0 from "./createDemand.vue?vue&type=style&index=0&id=7f56e1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56e1de",
  null
  
)

export default component.exports